import Client from '../axiosClient'
const resource = '/invoices';
const resourceEmail = '/booking-email';
const resourceInit = '/invoices-init/bootstrap';
const resourceChangeStatus = 'invoices-init/change-status';
const resourceStatusId = '/booking_by_status_id';
const resourcegeneratePdf = '/pdf';
const resourcecommunication =  '/communication';

export default {
  init(partnerId='') {
    let reqUrl = resourceInit;
    if(partnerId !=''){
      reqUrl += '?partnerId='+partnerId
    }
    return Client.get(`${reqUrl}`);
  },
  get() {
    return Client.get(`${resource}`);
  },

  getById(id) {
    return Client.get(`${resource}/${id}`);
  },

  changeStatus(payload) {
    return Client.post(`${resourceChangeStatus}`, payload);
  },

  getByStatusId (payload) {
    return Client.post(`${resourceStatusId}`, payload);
  },

  post(payload) {
    return Client.post(`${resource}`, payload);
  },
  sendEmail(payload) {
    return Client.post(`${resourceEmail}`, payload);
  },

  communication(payload){
    return Client.post(`${resourcecommunication}`, payload);
  },


  // MANY OTHER ENDPOINT RELATED STUFFS
};



// WEBPACK FOOTER //
// ./src/repositories/travel/invoiceRepository.js